import React, { useState, useEffect, Fragment } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import { renderMonthElement } from "../CalendarUtils";

export default function DateFilter({
  dateFilter,
  setDateFilter,
  clientView,
  start_date,
  end_date,
  onDatesChange,
  filterByInvoiceSentDate = false,
  only = false,
}) {
  const [focusedInput, setFocusedInput] = useState(null);

  const showFilter = (name) => !only || only.includes(name);

  return (
    <Fragment>
      <select
        value={dateFilter}
        onChange={(e) => setDateFilter(e.target.value)}
        className="form-control input-xs"
        style={{ height: 27 }}
      >
        {filterByInvoiceSentDate && (
          <option value="invoice_sent_date">Invoice Sent Date</option>
        )}
        {showFilter("registered") && (
          <option value="registered">{I18n.t("sample_registered_between")}</option>
        )}
        {showFilter("due_date") && (
          <option value="due_date">{I18n.t("sample_due_date_between")}</option>
        )}
        {showFilter("first_report_sent_date") && (
          <option value="first_report_sent_date">
            {I18n.t("report_sent_between_first_version_of_report")}
          </option>
        )}
        {showFilter("requested_test_date") && (
          <option value="requested_test_date">{I18n.t("requested_test_date")}</option>
        )}
        {showFilter("contract_review_date") && (
          <option value="contract_review_date">{I18n.t("contract_review_date")}</option>
        )}
        {showFilter("scheduled_date") && (
          <option value="scheduled_date">{I18n.t("with_tests_scheduled_between")}</option>
        )}
        {showFilter("tests_added_to_sample_date") && (
          <option value="tests_added_to_sample_date">
            {I18n.t("tests_added_to_sample_date")}
          </option>
        )}
        {showFilter("first_received_by_lab_date") && (
          <option value="first_received_by_lab_date">
            {I18n.t("first_received_by_lab_date")}
          </option>
        )}
        {showFilter("received_by_specific_lab") && (
          <option value="received_by_specific_lab">
            {I18n.t("received_by_specific_lab")}
          </option>
        )}
      </select>
      <DateRangePicker
        startDateId="start_date"
        startDate={start_date}
        endDateId="end_date"
        endDate={end_date}
        numberOfMonths={1}
        onDatesChange={({ startDate, endDate }) =>
          onDatesChange({ start_date: startDate, end_date: endDate })
        }
        focusedInput={focusedInput}
        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
        showClearDates={true}
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel={true}
        displayFormat="DD MMM YYYY"
        minimumNights={0}
        renderMonthElement={renderMonthElement}
      />
    </Fragment>
  );
}
